module.exports = __webpack_public_path__ + "static/media/logo.eaa33ca8.svg";